import type { WebUser } from "@/types/WebUser";
import { ThumbaCoin } from "@roman/shared/components/Icons";
import { Button } from "../ui/button";

export const PointsButton = ({
  user,
  onClick,
}: {
  user: WebUser;
  onClick: () => void;
}) => {
  const points = user.freePoints ? Number.parseInt(user.freePoints) : 0;
  const textSize =
    points >= 10000000 ? "text-xs md:text-base" : points >= 100000 ? "text-sm md:text-base" : "text-base";
  return (
    <Button
      variant="default"
      className="h-8 py-1 px-1.5 bg-gray hover:bg-gray/70 font-bold cursor-pointer flex justify-center items-center space-x-[2px] rounded-full"
      onClick={onClick}
    >
      <ThumbaCoin className="min-w-6 min-h-6" />

      <span className={`${textSize} text-black text-base font-semibold`}>{points}</span>

      {/* // Not part of release. */}
      {/* <PlusIcon className="text-green min-w-6 min-h-6" /> */}
    </Button>
  );
};
